import { DiscountGiftRow } from '@models/discount';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useMemo } from 'react';

interface Params {
    gift: DiscountGiftRow;
    isSelected: boolean;
    draftGiftAmount: number;
    alreadyBalanceSelected: boolean;
}

/** 선물을 고를 수 없는지 판단한다 */
function useGiftRowDisabled({
    gift, isSelected, draftGiftAmount, alreadyBalanceSelected,
}: Params) {
    const state = useCalculatedRequest();
    const { discountValue, couponType } = gift;

    // 교환권은 주문 금액이 교환권 금액 이상이어야 사용할 수 있다
    const disableByMinAmount = couponType === 'EXCHANGE' && discountValue > state.totalAmount;
    const disabled = useMemo(() => {
        if (isSelected) {
            return false;
        }
        const { totalAmount, prepaidCardAmount, totalDiscount } = state;
        if (disableByMinAmount) {
            return true;
        }
        if (state.pgAmount === 0) {
            return true;
        }
        if (couponType === 'BALANCE' && !alreadyBalanceSelected) {
            return false;
        }
        // 이미 남은 금액이 0원 이하일 때 사용 불가
        const leftAmount = totalAmount
            - draftGiftAmount
            - prepaidCardAmount
            - totalDiscount;
        return leftAmount < discountValue;
    }, [isSelected, draftGiftAmount, state, disableByMinAmount, discountValue, couponType, alreadyBalanceSelected]);

    return { disabled, disableByMinAmount };
}

export default useGiftRowDisabled;
